<template>
  <div id="app">
    <div class="RuleEngine-title">
      <div>{{ $t('rule_engine.title') }}</div>
    </div>
   <template>
        <Tabs size="small">
            <TabPane :label="$t('rule_engine.alertRule')">
                <table-alert-rule></table-alert-rule>
            </TabPane>
            <TabPane :label="$t('rule_engine.instance')">
                <table-instances></table-instances>
            </TabPane>
            <TabPane :label="$t('rule_engine.database')">
              <table-database></table-database>
            </TabPane>
            <TabPane :label="$t('rule_engine.storage')">
              <table-volume></table-volume>
            </TabPane>
        </Tabs>
    </template>
  </div>
</template>

<script>
    import TableVolume from '../rule_engine/TableVolume'
    import TableDatabase from '../rule_engine/TableDatabase'
    import TableInstances from '../rule_engine/TableInstances'
    import TableAlertRule from '../rule_engine/TableAlertRule'

    export default {
        name: 'RuleEngine',
        components: {
            TableInstances,
            TableDatabase,
            TableVolume,
            TableAlertRule
        },
        data() {
            return {
            }
        },
        mounted: function () {
            this.init()
        },
        methods: {
            init: function () {
                this.id = this.$route.query.id
            }
        }
    }
</script>

<style scoped>
  /*RuleEngine*/
  .RuleEngine-title {
    width: 100%;
    font-size: 13px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 15px 0px 8px 4px;
    font-weight: 600;
  }

  .RuleEngine-title > div:nth-child(1) {
    font-weight: 600;
    height: 24px;
  }

  .RuleEngine-main {
    width: 100%;
    height: 18px;
  }

  .RuleEngine-main > div {
    float: left;
    min-width: 11%;
    margin-right: 20px;
  }

  .RuleEngine-main span {
    font-weight: 600;
  }
</style>



// WEBPACK FOOTER //
// src/components/rule_engine/RuleEngine.vue